var React = require('react');

function CaretSquareLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zM288 372.6c0 10.14-14.07 15.21-22.29 8L131.82 264a10.38 10.38 0 0 1 0-16.08l133.89-116.57c8.22-7.16 22.29-2.09 22.29 8.05z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 372.6c0 10.14-14.07 15.21-22.29 8L131.82 264a10.38 10.38 0 0 1 0-16.08l133.89-116.57c8.22-7.16 22.29-2.09 22.29 8.05z","className":"fa-primary","key":2})]);
}

CaretSquareLeft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = CaretSquareLeft;

CaretSquareLeft.default = CaretSquareLeft;
